import { Button, DataGrid, Menu } from "devextreme-react";
import { Column } from "devextreme-react/cjs/data-grid";
import notify from "devextreme/ui/notify";
import { useEffect, useRef, useState } from "react";
import GlobalParams from '../../helpers/GlobalParams';
import axios from "axios";
import { Item } from "devextreme-react/cjs/context-menu";
import { EnquiriesForm } from "./EnquiriesForm";


export const EnquiriesGrid = () => {

    useEffect(() => {
        const fetchData = async () => {
            //setIsLoading(true);

            await fetchEnquiries(0);
            //setIsLoading(false);
        };
        fetchData(); // Initial fetch when the component mounts

        // Set up an interval to fetch data every 5 seconds
        if (!popupEnquiryVisible) {
            const intervalId = setInterval(async () => {
                fetchData();
            }, 5000); // 5000 milliseconds = 5 seconds

            // Clean up function to clear the interval when the component unmounts
            return () => {
                clearInterval(intervalId);
            };
        }
    }, []);


    const [isLoading, setIsLoading] = useState(false);
    const [enquiriesData, setEnquiriesData] = useState([]);
    const [popEnquiryTitle, setPopEnquiryTitle] = useState('');
    const formDataRef = useRef(null);
    const [scheme_id, set_scheme_id] = useState(null);
    const [MessageId, setMessageId] = useState(null);
    const [Response, setResponse] = useState('');
    const [Subject, setSubject] = useState('');
    const [coverPeriodsData, setCoverPeriodsData] = useState([]);
    const [popupEnquiryVisible, setPopupEnquiryVisible] = useState(false);
    const [vsEdit, setVsEdit] = useState(true);
    const [enquiryStore, setEnquiryStore] = useState();

    const handleCancelEnquiryButtonClick = () => {
        setPopupEnquiryVisible(false);
    }

    const fetchEnquiries = async (fetch_type) => {
        try {
            const result = await axios.get(
                GlobalParams.ApiUrlPrefix + "enquiries-under-client?portal_user_id=" + GlobalParams.ContactPersonId,
                {
                    headers: {
                        'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
                    }
                }
            );
            setIsLoading(false);
            setEnquiriesData(result.data.data);
            if (fetch_type === 1) {
                //clear_form();
                setPopupEnquiryVisible(false);
            }
        } catch (error) {
            // Handle error, e.g., show an error message
            console.log(error);
            notify(error.response.data.message, 'error', 5000);
        }
    };

    const menuItems = [
        { text: 'Reply', icon: 'edit' }
    ];
    const onMenuItemClick = (cellInfo, item) => {
        if (item === 'Reply') {

            if (cellInfo.data.Response === null || cellInfo.data.Response === undefined ||
                cellInfo.data.Response === '') {
                notify("Kindly wait for an Inbox / Response from Britam in order to Respond", 'error', 5000);
            } else {
                console.log('Reply');
                setPopEnquiryTitle('Reply Enquiry');
                //formDataRef.current.instance.updateData('Subject', cellInfo.data.Subject);
                setPopupEnquiryVisible(true);
                setVsEdit(true);
                setResponse(cellInfo.data.Response);
                setSubject(cellInfo.data.Subject);

                setEnquiryStore({ ...enquiryStore, Subject: cellInfo.data.Subject });
                setEnquiryStore({ ...enquiryStore, Response: cellInfo.data.Response });
                setEnquiryStore({ ...enquiryStore, isNew: false });
            }

        }
    };
    const actionColumnTemplate = (cellInfo) => {
        return (
            <div>
                <Menu
                    onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
                >
                    <Item
                        text=" "
                        items={menuItems}
                    >
                    </Item>
                </Menu>
            </div>
        );
    };

    return (
        <div>
            {popupEnquiryVisible && <EnquiriesForm open={popupEnquiryVisible}
                onClose={handleCancelEnquiryButtonClick}
                title={popEnquiryTitle}
                vsEdit={true}
                MessageId={MessageId}
                scheme_id={scheme_id}
                Subject={Subject}
                Response={Response} />
            }
            <DataGrid dataSource={enquiriesData}
                wordWrapEnabled={true}
                grouping={{ autoExpandAll: true }}
            >
                {/* <Column width={50} caption="" visible={true} cellRender={actionColumnTemplate} /> */}
                <Column cellRender={(cellInfo) => {
                    return (
                        <div>
                            <Button
                                text="Reply"
                                type='default'
                                icon='message'
                                disabled={(cellInfo.data.Status === "2" || (cellInfo.data.Response === null || cellInfo.data.Response === undefined ||
                                    cellInfo.data.Response === ''))}
                                onClick={
                                    () => {
                                        if(cellInfo.data.Status === "2"){
                                            notify("The Enquiry is closed. Kindly iniate a new Enquiry", 'error', 5000);
                                        }else{
                                            if (cellInfo.data.Response === null || cellInfo.data.Response === undefined ||
                                                cellInfo.data.Response === '') {
                                                notify("Kindly wait for an Inbox / Response from Britam in order to Respond", 'error', 5000);
                                            } else {
                                                console.log('Reply');
                                                setPopEnquiryTitle('Reply Enquiry');
                                                //formDataRef.current.instance.updateData('Subject', cellInfo.data.Subject);
                                                setPopupEnquiryVisible(true);
                                                setVsEdit(true);
                                                setResponse(cellInfo.data.Response);
                                                setSubject(cellInfo.data.Subject);
                                                set_scheme_id(cellInfo.data.SchemeId);
                                                setMessageId(cellInfo.data.MessageId);
    
                                                setEnquiryStore({ ...enquiryStore, scheme_id: cellInfo.data.schemeID });
                                                setEnquiryStore({ ...enquiryStore, Subject: cellInfo.data.Subject });
                                                setEnquiryStore({ ...enquiryStore, Response: cellInfo.data.Response });
                                                setEnquiryStore({ ...enquiryStore, isNew: false });
                                            }
                                        }
                                        
                                    }
                                }
                            />
                        </div>
                    );
                }}>
                </Column>
                <Column dataField="Id" visible={false}></Column>
                <Column dataField="MessageId" visible={false}></Column>
                <Column dataField="SchemeId" groupIndex={0}
                    lookup={
                        { dataSource: GlobalParams.schemeStore, valueExpr: 'schemeID', displayExpr: 'PolicyCompany' }
                    }>
                </Column>
                <Column dataField="Subject" groupIndex={0}
                    lookup={
                        { dataSource: GlobalParams.EnquiriesSubjects, valueExpr: 'Id', displayExpr: 'Description' }}>

                </Column>
                <Column dataField="Narration" caption='OutBox' ></Column>
                {/* <Column
                dataField="created_on" caption='OutBox Date'
                dataType="datetime" width={120}>
            </Column> */}
                <Column dataField="Response" caption='InBox' ></Column>
                {/* <Column
                dataField="created_on" caption='InBox Date'
                dataType="datetime" width={120}>
            </Column> */}
                <Column dataField="Status"
                    lookup={
                        { dataSource: GlobalParams.EnquiryStatuses, valueExpr: 'Id', displayExpr: 'Description' }}>
                </Column>
                <Column visible={false} dataField="FileName"></Column>
                <Column visible={false} cellRender={(cellInfo) => {
                    return (
                        <div>
                            <Button
                                text=""
                                type='danger'
                                icon='attach'
                                onClick={
                                    () => {
                                        //download the file
                                        let filename = cellInfo.data.FileName;
                                        console.log(filename);
                                        const anchor = document.createElement('a');
                                        anchor.href = GlobalParams.EnquiryFileUrl + filename;
                                        anchor.download = filename; // Set the filename for download
                                        anchor.click();
                                    }
                                }
                            />
                        </div>
                    );
                }}></Column>
            </DataGrid>
        </div>
    );

}